import type {
  CSSProperties,
  HTMLAttributes,
  ReactNode,
} from 'react';

export interface InteractiveViewerRootProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  children: ReactNode;
  loading?: boolean;
  loadingOverlay?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const InteractiveViewerRoot = ({
  children,
  loading = false,
  loadingOverlay,
  className = '',
  ...props
}: InteractiveViewerRootProps) => (
  <div
    {...props}
    className={`iv-viewer iv-viewer-root ${className}`.trim()}
    data-tour-id="iv-viewer-root"
  >
    {loading ? (
      <div className="iv-viewer-root__loading">
        {loadingOverlay ?? (
          <div role="status" aria-live="polite">
            Loading viewer…
          </div>
        )}
      </div>
    ) : null}
    {children}
  </div>
);
